export const generatePrompts = (data) => {
    return fetch('/api/v1/prompts-from-entities/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
        body: JSON.stringify(data),
    });
};

export const getGeneratedPromptsApi = (id) => {
    return fetch(`/api/v1/prompts-from-entities/${id}/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
};
